<template>
  <v-dialog :value="modalType === 'tester'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          <span v-if="checkRoute">Chuyển người phỏng vấn</span>
          <span v-else-if="isCreate">Thêm mới phễu chăm sóc</span>
          <span v-else>Cập nhật phễu chăm sóc</span>
          <v-spacer/>
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-spacer/>
        <v-spacer/>
        <v-card-text class="px-6">
          <p class="text-sm-left" style="margin-bottom: 0px">Tên phễu chăm sóc <span style="color: red">*</span></p>
          <v-row>
            <v-col cols="12" md="12">
              <v-form ref="entryForm">
              <v-text-field
                v-model="inputForm.name"
                :rules="rules"
                counter
                maxlength="500"
                placeholder="Nhập tên phễu"
              ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="px-6">
          <p class="text-sm-left" style="margin-bottom: 0px">Người phụ trách <span style="color: red">*</span></p>
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                :name="checkRoute ? 'Chuyển tester' : 'Thêm người vận hành'"
              >
                <common-select-user
                  v-model="inputForm.testerId"
                  :items="users"
                  color="primary"
                  :placeholder="'Chọn người phụ trách'"
                  item-text="fullName"
                  item-value="id"
                  :error-messages="errors"
                  :multiple="true"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="#BDBDBD" style="color: #FFFFFF" @click="hideModal">Hủy bỏ</v-btn>
          <v-spacer/>
          <v-btn color="#E91E63" style="color: #FFFFFF" @click.prevent="handleSubmit(saveChange)" @click="$refs.entryForm.validate()"
          >Lưu Lại
          </v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    modalType: {
      default: () => ({}),
    },
    users: {
      type: Array,
      default: () => [],
    },
    contactsSelected: {
      type: Array,
      default: () => [],
    },
    checkRoute: {
      type: Boolean,
      default: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    inputForm: {
      default: () => ({}),
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      testerId: '',
      groupName: '',
      rules: [(v) => v.length <= 500 || 'Tối đa 500 kí tự', (v) => v !== '' || 'Tên phễu chăm sóc bắt buộc'],
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    hideModal() {
      this.errorMessage = '';
      this.userId = '';
      this.$emit('hide-modal');
    },
    async saveChange() {
      if (this.$refs.entryForm.validate()) {
        console.log('saved');
      }
    },
  },
};
</script>
